import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './companyInfo.module.scss'
import { ICompanyProps } from '../../../signup-v3/dooerPreOffer'

export default function CompanyInfo({ company }: { company: ICompanyProps }) {
  return company && company.accountingOnboardingSyncedPreOffer ? (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          {company.name && (
            <h2>
              <FormattedMessage
                defaultMessage="Om {company}"
                id="sync-bank.components.heading"
                values={{ company: company.name }}
              />
            </h2>
          )}

          <div className={styles.infoWrapper}>
            {company.accountingOnboardingSyncedPreOffer.syncedCompanyInfo &&
            company.accountingOnboardingSyncedPreOffer.syncedCompanyInfo.length
              ? company.accountingOnboardingSyncedPreOffer.syncedCompanyInfo.map(
                  (infoRow: { propertyMessage: string; propertyValue: string }) => (
                    <div className={styles.row} key={infoRow.propertyMessage}>
                      <h4>{`${infoRow.propertyMessage}:`}</h4>
                      <h4>{infoRow.propertyValue}</h4>
                    </div>
                  )
                )
              : null}

            {company.accountingOnboardingSyncedPreOffer.syncedBankInfo &&
            company.accountingOnboardingSyncedPreOffer.syncedBankInfo.length
              ? company.accountingOnboardingSyncedPreOffer.syncedBankInfo.map(
                  (infoRow: { propertyMessage: string; propertyValue: string }) => (
                    <div className={styles.row} key={infoRow.propertyMessage}>
                      <h4>{`${infoRow.propertyMessage}:`}</h4>
                      <h4>{infoRow.propertyValue}</h4>
                    </div>
                  )
                )
              : null}
          </div>
        </div>
      </div>
    </div>
  ) : null
}
